<template>
	<div id="appbox">
		<div class="top_heard">
				<div class="top_box"  v-if="screenWidth>785" >
					<div class="logo_box"  @click="gohome()">
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div>
					<div class="top_gatebox">
						<div class="manage_switch" v-if="screenWidth>785">
							<el-select v-model="manage_url" @change="manageurl"  size="small" class="Site_switch_type" placeholder="选择入口">
							  <el-option
							    v-for="item in manageoptions"
							    :key="item.value"
							    :label="item.label"
							    :value="item.value"
								>
							  </el-option>
							</el-select>
						</div>
						
					</div>
					<div class="top_search_box" v-if="screenWidth>785" >
						<div class="top_search">
							<el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
							  <el-option
							    v-for="item in options"
							    :key="item.value"
							    :label="item.label"
							    :value="item.value"
								
								>
							  </el-option>
							</el-select>
							<!-- <i class="el-icon-search"></i> -->
							<input type="text" v-model="stitle" autocomplete="off" placeholder="搜索关键词……" class="el-input__inner"  style="border: 0px;width: 200px;height: 30px;">
							<img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" @click="gotopsearch()" alt="" srcset="">
						</div>
						  
					</div>
					<div class="top_right">
						<div class="top_Mobiletype" @click="goregister()">
							账号注册/绑定
						</div>
						<div class=""  v-if="token" >
							欢迎访问!
						</div>
						<div class=""  v-if="token"  style="color: darkred;margin-left: 5px;" @click="logout()" >
							登出
						</div>
					</div>
				</div>
				<div class="top_tab_box">
					<van-nav-bar title="" style="color: #ffffff ;font-weight: 600;" @click-right="vannavshow=true" v-if="screenWidth<785" >
						<template #left>
							<div class="vannav_title" style="color: #217495;font-size: 16px;" >
								机构详情
							</div>
						</template>
						<template #title>
							<div class="vannav_title" style="width: 180px;padding: 20px;">
									<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
							</div>
						</template>
					  <template #right>
						  <van-icon name="ellipsis"  size="20"    />
					  </template>
					</van-nav-bar>
					<van-popup v-model="vannavshow"  :style="{ height: '50%' }" position="top">
						<van-picker
						  title=""
						  show-toolbar
						  :columns="vannavlist"
						  confirm-button-text="进入"
						  @confirm="vanlinkgo"
						  @cancel="vannavmenushow"
						
						/>
					</van-popup>
					<div class="toptabnav" v-if="screenWidth>785" >
							<el-menu
							  :default-active="activeIndex2"
							  class="el-menu-demo"
							  mode="horizontal"
							  @select="handleSelect"
							  router
							  background-color="#1b9d57"
							  text-color="#FFFFFF"
							  active-text-color="#FFFFFF">
								<el-menu-item index="/Home"  >首页</el-menu-item>
						<el-menu-item index="/Newslist" >研学资讯</el-menu-item>
						<el-menu-item index="/Campmap" >研学地图</el-menu-item>
						
						<el-submenu index="/institution">
						    <template slot="title">研学单位</template>
						    <el-menu-item index="/Camplist" >研学营地</el-menu-item>
						    <el-menu-item index="/Baselist" >研学基地</el-menu-item>
						    <el-menu-item index="/traveler" >研学机构</el-menu-item>
						  </el-submenu>
						
							<el-submenu index="/Courselist">
						    <template slot="title">研学产品</template>
						    <el-menu-item index="/Courselist" >研学课程</el-menu-item>
						<el-menu-item index="/Linelist" >研学线路</el-menu-item>
						  </el-submenu>
						  	<el-submenu index="/authLesson">
						    <template slot="title">认证申请</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/authLesson" >课程认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >基地认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >机构认证申请</el-menu-item>
						   
						  </el-submenu>
<!--						<el-menu-item index="/Activitylist">活动中心</el-menu-item>-->
						<el-submenu index="/Mentorlist">
						    <template slot="title">证书管理</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/Mentorlist" >导师证书查询</el-menu-item>
						   
						  </el-submenu>
						  
              			
						<el-menu-item index="/expertlist" >智库专家</el-menu-item>
             			<el-menu-item index="/OrgRegister" >入驻平台</el-menu-item>
							<!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
						</el-menu>
					</div>
				</div>
			</div>
		<div class="main_box" :style="screenWidth>785?'':'width:100%;'">
			<div class="acttop_box" :style="screenWidth>785?'':'width:100%; flex-direction: column;'">
				<div class="acttop_imgs" :style="screenWidth>375?'':'padding:10px 0px;'">
					    <el-carousel :height="screenWidth>375?'210px':(screenWidth*210/375)+'px'">
					      <el-carousel-item v-for="item in 1" :key="item">
					        <h3 class="small"><img :src="actdata.icon" style="width: 100%;height: 100%;" alt="" srcset=""></h3>
					      </el-carousel-item>
					    </el-carousel>
				</div>
				<div class="acttop_msg" :style="screenWidth>785?'':'width:calc(100% - 40px);padding:10px;'">
					<el-descriptions class="margin-top" :style="screenWidth>785?'':'width:100%;'" :title="actdata.title" :column="screenWidth>785?2:1" border>
					    <!-- <el-descriptions-item   label-class-name="my-label"  v-if="screenWidth>785" >
					      <template slot="label">
					        <i class="el-icon-user"></i>
					        法人代表姓名
					      </template>
						  <div class="secret_msg">
							{{secretshow?actdata.legal_title:'********'}}
								<div class="">
									<i class="el-icon-turn-off" v-if="secretshow" @click="secretswitch(false)" ></i>	
									<i class="el-icon-open" v-if="!secretshow" @click="secretswitch(true)" ></i>
								</div>
						    </div> 	 
					    </el-descriptions-item>
					    <el-descriptions-item label-class-name="my-label"  v-if="screenWidth>785" >
					      <template slot="label">
					        <i class="el-icon-mobile-phone"></i>
					        工商营业执照号
					      </template>
					      {{actdata.business_number}}
					    </el-descriptions-item> -->
						<el-descriptions-item label-class-name="my-label"  v-if="screenWidth>785" >
						  <template slot="label">
						    旅行社经营许可证
						  </template>
						  {{actdata.business_license}}
						</el-descriptions-item>
					    <!-- <el-descriptions-item label-class-name="my-label">
					      <template slot="label">
					        <i class="el-icon-location-outline"></i>
					        单位开办年月
					      </template>
						  {{actdata.establishment_date}}
					    </el-descriptions-item> -->
						<!-- <el-descriptions-item label-class-name="my-label" >
						  <template slot="label">
						    <i class="el-icon-location-outline"></i>
						    注册资金(万元)
						  </template>
						  <div style="color: red;">
							   {{actdata.registered_capital}}
						  </div>
						</el-descriptions-item> -->
		<!-- 				<el-descriptions-item label-class-name="my-label">
						  <template slot="label">
						    活动线路
						  </template>
							{{actdata.route.title}}
						</el-descriptions-item> -->
					    <el-descriptions-item label-class-name="my-label">
					      <template slot="label">
					        研学负责人
					      </template>
						  <div class="secret_msg">
							{{actdata.head_title}}

							<!-- {{secretshow?actdata.head_title:'********'}} -->
								<div class="">
									<i class="el-icon-turn-off" v-if="secretshow" @click="secretswitch(false)" ></i>	
									<i class="el-icon-open" v-if="!secretshow" @click="secretswitch(true)" ></i>
								</div>
						    </div> 	
					    </el-descriptions-item>
						<el-descriptions-item label-class-name="my-label">
						  <template slot="label">
						    负责人联系电话
						  </template>
						  <div class="secret_msg">
							{{actdata.head_mobile}}
							<!-- {{secretshow?actdata.head_mobile:'********'}} -->
								<div class="">
									<i class="el-icon-turn-off" v-if="secretshow" @click="secretswitch(false)" ></i>	
									<i class="el-icon-open" v-if="!secretshow" @click="secretswitch(true)" ></i>
								</div>
						    </div> 
						</el-descriptions-item>
						<!-- <el-descriptions-item label-class-name="my-label">
						  <template slot="label">
						    单位员工人数
						  </template>
						  <div class="">
						  	{{actdata.employee}}
						  </div>
						</el-descriptions-item> -->
						<el-descriptions-item label-class-name="my-label">
						  <template slot="label">
						    研学指导师人数
						  </template>
						  <div class="" >
						  	{{actdata.teachers}}
						  </div>
						</el-descriptions-item>
						<el-descriptions-item label-class-name="my-label">
						  <template slot="label">
						    详细地址
						  </template>
						  <div class="">
						  	{{actdata.address}}
						  </div>
						</el-descriptions-item>
					  </el-descriptions>
				</div>
			</div>
			<el-tabs>
				<el-tab-pane label="企业资质">
					<div class="act_main" style="width:100%;">
				<div class="actmain_item">
					<div class="actmain_title">
						<span class="actblock" ></span>研学机构简介
					</div>
					<div class="richbox" v-html="actdata.survey"></div>
				</div>
				<div class="actmain_item">
					<div class="actmain_title">
						<span class="actblock" ></span>研学机构所在地
					</div>
					<div class="traveler_map">
						<baidu-map class="bm-view" :style="screenWidth>785?'':'width:100%;aspect-ratio: 1/1;height:auto;'" :center="{lng:actdata.longitude, lat: actdata.latitude}" :zoom="12"  :scroll-wheel-zoom="true">
							<!-- <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list> -->
							<!-- <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true"  :autoLocation="true"></bm-geolocation> -->
							<bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
						    <bm-marker :position="{lng:actdata.longitude, lat: actdata.latitude}" :dragging="false">
								<bm-label :content="actdata.title" :labelStyle="{color: '#67c23a', fontSize : '12px',border:'1px solid #67c23a',}" :offset="{width: -35, height: 30}"/>
						    </bm-marker>
							<bm-info-window :show="true" :closeOnClick="false" :width="361" :position="{lng:actdata.longitude, lat: actdata.latitude}" :title="actdata.title" :offset="{width: 0, height: -30}" >
								<div style="color:#333;font-size:16px;">
									   <div style="margin-top:5px;height: 2px; width:100%;background-color: #1b9d57 !important;"></div>
									   <div style="margin-top:5px;width:340px">  详细地址：{{ actdata.address }}</div>
									   <div style="margin-top:5px;width:340px">  联系方式：{{ actdata.head_mobile }}</div>
									   <!-- <div style="margin-top:5px;height: 2px; width:100%;background-color: #1b9d57 !important;"></div> -->
									<!-- <div style="margin-top:5px;width:220px">  指派人：{{ point.orderPeopleStr }}</div>
									   <div style="margin-top:5px;width:220px">  故障开始时间：{{ point.repairStartTime }}</div>
									   <div style="margin-top:5px;width:220px">  详细信息：{{ point.information }}</div> -->
								 </div>
							</bm-info-window>
						  </baidu-map>
					</div>
				</div>
			</div>
				</el-tab-pane>
				<el-tab-pane label="精品线路">
					<div class="camplist" :style="screenWidth>785?'':'width:100%;'">
				<div class="campitems" :style="screenWidth>785?'':'width:calc(100% - 30px);flex-direction: column;padding:15px;'"   v-for="item in camplist" :key="item" @click="detail(item.id)"  >
					<div class="campitem_imgbox" :style="screenWidth>785?'':'width:100%;aspect-ratio: 337/161;height:auto;'">
						<img :src="item.icon" alt="" srcset="">
					
					</div>
					<div class="campitem_msg" :style="screenWidth>785?'':'width:100%;padding-top:15px;margin:0px;height:auto;min-height: 101px;'">
						<div class="campitem_msg_title"  :style="screenWidth>785?'':'width:'+(screenWidth-30)+'px;'">
							<!-- <span>{{item.type}}</span> -->
							<i class="el-icon-guide" style="color:#1b9d57 ;margin-right: 10px;"></i>
							<div class="" :style="screenWidth>785?'text-align: left;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;':'text-align: left;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;font-size:16px;width:'+(screenWidth-100)+'px;'">
								{{item.title}}
							</div>
						</div>
						<div class="campitem_msg_introduce">
							
							<div class="campitem_tags" v-if="item.lesson.length" :style="screenWidth>785?'':'flex-wrap: wrap;'">
								<i class="el-icon-medal" style="color:#1b9d57 ;margin-right: 10px;"></i>
								线路成分：
								  <el-tag
								    v-for="tag in item.lesson"
									size="small"
								    :key="tag"
									:color="tag.color"
									style="margin-right: 5px;"
								    effect="dark">
								    {{tag.title}}
								  </el-tag>
							</div>
							<div class="introduce">
								<i class="el-icon-office-building" style="color:#1b9d57 ;margin-right: 10px;"></i>
								<div :style="screenWidth>785?'text-align: left;':'text-align: left;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;width:'+(screenWidth-60)+'px;'" >发起单位：{{item.unit}}</div>
								
							</div>
							<div class="campitem_tags" :style="screenWidth>785?'':'flex-wrap: wrap;'">
										<i class="el-icon-medal" style="color:#1b9d57 ;margin-right: 10px;"></i>
										适用学段：
										  <el-tag
										    v-for="tag in item.periods"
											size="small"
										    :key="tag"
											:color="tag.color"
											style="margin-right: 5px;"
										    effect="dark">
										    {{tag.title}}
										  </el-tag>
									</div>
									<div class="introduce">
										<i class="el-icon-timer" style="color:#1b9d57 ;margin-right: 10px;"></i>
										<div :style="screenWidth>785?'text-align: left;':'text-align: left;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;width:'+(screenWidth-60)+'px;'" >线路天数：{{item.days}}</div>
										
									</div>
								<div class="introduce">
									<i class="el-icon-view" style="color:#1b9d57 ;margin-right: 10px;"></i>
									<div :style="screenWidth>785?'text-align: left;':'text-align: left;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;width:'+(screenWidth-60)+'px;'" >浏览总量：{{item.uv}}</div>
									
								</div>
							<div class="introduce">
								<i class="el-icon-reading" style="color:#1b9d57 ;margin-right: 10px;"></i>线路课程：{{item.lesson_nums}}节
							</div>
						</div>
						<div class="campitem_msg_button" v-if="screenWidth>785">
							<div class="msg_button" >
								查看详情
							</div>
						</div>
					</div>
				</div>
				<div class="pages_total">
					<el-pagination
					  background
					  :page-size="10"
					  :hide-on-single-page="true"
					  @current-change="pagechangeLine"
					  layout="total, prev, pager, next"
					  :total="total">
					</el-pagination>
				</div>
			</div>

				</el-tab-pane>
				<el-tab-pane label="研学产品">
					<div class="course_box" :style="screenWidth>785?'':'width:100%; justify-content: center;'">
				<div class="coures_item" v-for="item in courselist" :key="item"  @click="detailCourse(item.id)"  >
					<div class="coures_item_icon">
						<img :src="item.icon" alt="" srcset="">
						<div class="coures_item_type">
							<span v-for="tags in item.camp_lcategory" :key="tags" :style="'background-color:'+tags.color+';'">{{tags.title}}</span>
						</div>
					</div>
					<div class="coures_item_title">
						{{item.title}}
					</div>
					<div class="coures_item_msg">
						<div class="">
							课程时间：<span style="color: #1b9d57;">{{item.research_class}}</span>课时	
						</div>
						<div class="">
							浏览量:<span style="color: #1b9d57;">{{item.uv}}</span>
						</div>
					</div>
					<div class="coures_item_tags">
						<div class="campitem_tag" v-for="tag in item.periods_data" :key="tag" :style="'color:'+tag.color+';background:'+tag.background+';'" >
							{{tag.title}}
						</div>
					</div>
				</div>
				<div class="pages_total">
					<el-pagination
					  background
					  :page-size="12"
					  :small="screenWidth<785"
					  :pager-count="screenWidth>785?7:5"
					  :hide-on-single-page="true"
					  @current-change="pagechangeCourse"
					  layout="total, prev, pager, next"
					  :total="total">
					</el-pagination>
				</div>
			</div>
				</el-tab-pane>
			</el-tabs>
			
		</div>
<!-- 		<div class="swim_box">
			<div class="swim_title">
				报名活动
			</div>
			<div class="swim_code">
				<img :src="actdata.sun_code" alt="" srcset="">
			</div>
		</div> -->
		<div :class="tops?'navbar':'navbar-top'" v-if="screenWidth>785" >
		     <el-tooltip class="item" effect="dark" content="返回首页" placement="left">
		             <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"  @click="gohome()"><i class="el-icon-s-home"></i>
								<div style="font-size: 14px;">首页</div></a>
		     </el-tooltip>
		     <div  class="qrShow3 right2"   v-if="showofficialQR">
					<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showofficialQRCode" @mouseleave="hideofficialQRCode"><i class="el-icon-s-help"></i>  
							
				    <div style="font-size: 14px;">公众号</div></a>
				<div  class="qrShow2 right2" v-if="showserviceQR">
					<img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>  
							
				    <div style="font-size: 14px;">客服</div></a>
		     <div  class="qrShow right" v-if="showQR">
							<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
		     </div>
		       <!-- <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showQRCode" @mouseleave="hideQRCode"><i class="el-icon-mobile-phone"></i> 
					
		         <div style="font-size: 14px;">手机端</div></a> -->
		     <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
		         <a @click="gotop"><i class="el-icon-caret-top"></i>
		         <br>
		         <span>顶部</span></a>
		     </el-tooltip>
		 </div>
		<!-- footer -->
		<div class="pagesbottom_box"  :style="screenWidth>785?'':'width:100%;'" >
			<div class="subtexts" v-if="screenWidth>785" >
				<div v-for="(item, key) in bottomnav" :key="key" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
			</div>
			<div class="subnavbox" v-if="screenWidth<785" >
				<div class="subtext_title">
					关于研学平台
				</div>
				<div class="subtexts" :style="screenWidth>785?'':'width:calc(100% - 40px);flex-wrap:wrap;padding:20px;margin-top: 0px;'" >
					<div v-for="(item, key) in bottomnav" :key="key" :style="screenWidth>785?'':'width:25%;text-align: left;margin-bottom:15px'"  @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				</div>
			</div>
		<div class="footer_box">
			<div class="row"  :style="screenWidth>785?'padding-bottom:0px':'width:calc(100% - 20px);padding:0px 10px;padding-bottom:0px'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						指导单位：河南省教育厅   主办单位：河南省研学旅行教育协会
					</div>
				</div>
				
			</div>
			<div class="row"  :style="screenWidth>785?'':'width:calc(100% - 20px);padding:0px 10px;'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>
				
			</div>
		</div>
		</div>
	</div>
</template>

<script>
	import { getActypes, getActivitylist, getPc ,getTraveler,getbottomnav,getLinelist,getCourselist } from '@/request/api'
	
	export default {
	  name: "traveler",
	    // components: {
	    //   navTab
	    // },
	  data(){
		  return {
			  bottomnav:[],
			  stitle:"",
	phoneboxshow:false,
				//搜索相关
				top_search_url:'/Siteall',
				options: [
				{
					value: '/Siteall',
					label: '全站搜索'
				},{
				  value: '/Camplist',
				  label: '营地搜索'
				}, {
				  value: '/Baselist',
				  label: '基地搜索'
				}, {
				  value: '/Courselist',
				  label: '课程搜索'
				},{
				  value: '/Newslist',
				  label: '资讯搜索'
				},
				{
				  value: '/Activitylist',
				  label: '活动搜索'
				},
				{
				  value: '/Linelist',
				  label: '线路搜索'
				},
				{
				  value: '/traveler',
				  label: '机构搜索'
				},{
				  value: '/mentorlist',
				  label: '指导师搜索'
				},],
				//搜索相关
			manage_url:'',
			manageoptions:[
				{
				  value: 'http://qianjin.wanjiaxiao.cn/',
				  label: '研学报备'
				}, {
				  value: 'https://admin.henanyanxue.com/',
				  label: '管理入口'
				},
				 
			],
			activeIndex2: '/traveler',
			userInfo: {
			  username: "",
			  education_name: "",
			  role_level: ""
			},
			logintype:true,
			banner:[
			],
			types:[],
			actlist:[],
			quicklist:[],
			aclist:[],
			newsiconon:'',
			category_id:0,
			total:0,
			page_index:1,
			page_index_course:1,
			secretshow:false,
			actdata:{},
			uuid:'',
			pcsetdata:{},
			camplist:[],
			// 研学产品
			courselist:[],
			//侧边栏
			 showQR:false,
			 showserviceQR:false,
			  showofficialQR:false,
			tops:false,
			heights:window.innerHeight,
			scrolltop:'',
			//屏幕宽高
			// 屏幕宽度
			screenWidth: window.innerWidth,
			top_bannerWidth:Math.round(window.innerWidth/3.42),
			// 屏幕高度
			screenHeight: window.innerHeight,
			//手机端导航栏
			vannavshow:false,
			vannavlist:[
				{
					link:'/Home',
					text:'研学首页'
				},
				{
					link:'/Camplist',
					text:'营地列表'
				},
				{
					link:'/Newslist',
					text:'资讯资讯'
				},
				{
					link:'/Baselist',
					text:'基地列表'
				},
				{
					link:'/Courselist',
					text:'研学课程'
				},
				{
					link:'/Activitylist',
					text:'研学活动'
				},
				{
					link:'/Linelist',
					text:'研学线路'
				},
				{
					link:'/traveler',
					text:'研学机构'
				},
				{
					link:'/mentorlist',
					text:'研学指导师'
				},
				{
					link:'/expertlist',
					text:'专家团队'
				},
        {
          link: '/OrgRegister',
          text: '入驻平台'
        },
			],
		  }
	  },
	  beforeCreate(){
	  	   const loading = this.$loading({
	  	            lock: true,
	  	            text: '页面载入……',
	  	            // spinner: 'el-icon-loading',
	  	            background: '#ffffff'
	  	          });
	  },
	  created() {
		   this.getpcset()
	  },
	  mounted() {
		 const { id } = this.$route.query;
		 window.addEventListener('resize', this.handleResize, true)
		 this.uuid = id
		 var token = localStorage.getItem('token')||''
		 this.token=token
		 this.getDetails()
		 this.getlist()
		  this.getbottomnav()
		window.addEventListener('scroll', this.scrollToTop)
				
		},
		 destroyed () {
		        window.removeEventListener('scroll', this.scrollToTop)
		  },
	  // 销毁监听
	  		beforeDestroy() {
	  		  window.removeEventListener('resize', this.handleResize);
	  		},
	  methods: {
		getlist(){
			var data={
				page_index: this.page_index,
				employ_id:this.uuid,
				page_size: 10,
			}  
			getLinelist(data).then(res=>{
				console.log(res.data)
				this.camplist=res.data.data.list
				this.total=res.data.data.total
				// this.quicklist=res.data.data.list
			}).catch(error => {
				console.error(error);
			});
			var coursedata={
				page_index: this.page_index_course,
				employ_id:this.uuid,
				page_size: 12,
			}  
			getCourselist(coursedata).then(res=>{
				console.log(res.data)
				this.courselist=res.data.data.list
				this.total=res.data.data.total
				// this.quicklist=res.data.data.list
			}).catch(error => {
				console.error(error);
			});
		  },
		//   查看详情
		detail(e) {
		    this.$router.push({
		      path: "/LineDetails",
		      name: "LineDetails",
		      query: {
		        id: e
		      }
		    });
		  },
		//   查看课程详情
		  detailCourse(e) {
		    this.$router.push({
		      path: "/CourseDetails",
		      name: "CourseDetails",
		      query: {
		        id: e
		      }
		    });
		  },
		  gotopsearch(){
		  		  this.$router.push({
		  		    path: this.top_search_url,
		  		    name: this.top_search_url,
		  		    query: {
		  		      stitle: this.stitle,
		  		    }
		  		  }); 
		  },
		  manageurl(e){
		  		  console.log('Site',e)
		  		  if(e!='/'){
		  			   window.open(e) 
		  		  }
		  		//this.manage_url='/'
		  		  // window.location.href = e;
		  		  
		  },
	  		  vanlinkgo(e){
	  		  		  console.log(e)
	  		  		  this.$router.push({
	  		  		    path: e.link,
	  		  		    name: e.link,
	  		  		    query: {
	  		  		    }
	  		  		  }); 
	  		  },
	  		  vannavmenushow(){
	  		  		this.vannavshow=false  
	  		  },
	  		  handleResize() {
	  		  		   this.top_bannerWidth = 0;
	  		    this.screenWidth = window.innerWidth;
	  		  		this.top_bannerWidth=window.innerWidth/3.42
	  		  		console.log('screenWidth',this.screenWidth,this.top_bannerWidth)
	  		    this.screenHeight = window.innerHeight;
	  		  },
			gologin(){
		  			  this.$router.push({
		  			    path: "/Login",
		  			    name: "/Login",
		  				  query: {
		  				  }
		  			  });
		    },  

			secretswitch(showtype){
			  var that=this
			  var token = localStorage.getItem('token')||''
			  if(!token){
			    this.gologin()
			    return
			  }
			  // if(showtype){
					// 	checktoken(data).then(res=>{
					// 	    if(res.data.code==201){
					// 	  	  console.log(res)
					// 	  	  regettoken(data).then(res=>{
					// 	  		  localStorage.setItem('token', res.data.data.token)
					// 	  		  localStorage.setItem('refreshToken', res.data.data.refreshToken)
					// 	  	  })
					// 	    }
					// 	})
					// 	data={
					// 	  type:1,
					// 	  type_id:that.uuid
					// 	}
					// 	looksecretup(data).then(res=>{
					// 		that.secretshow=showtype
					// 	})
				 //  var data={
				    
				 //  }
			  // }
			  console.log(showtype)
			  this.secretshow=showtype
		  },	  
		  getbottomnav(){
		  		  var data={
		  			  page_index:1,
		  			  page_size:15
		  		  }
		  		getbottomnav(data).then(res=>{
		  			this.bottomnav=res.data.data.list
		  		})  
		  },
		  gobottomnav(type,link){
		  		  if(type==1){
		  			  this.$router.push({
		  			  	path:link
		  			  });
		  		  }else if(type==2){
			  window.location.href = link;
		  }
		  },
		  logout(){
		  			  var that=this
		  			  this.$confirm('是否确认退出登录?', '提示', {
		  			  					confirmButtonText: '确定',
		  			  					cancelButtonText: '取消',
		  			  					type: 'warning'
		  			  }).then(() => {
		  						this.$alert("已退出登录", '', {
		  							confirmButtonText: '确认',
		  							callback: action => {
		  								localStorage.setItem('token', '')
		  								localStorage.setItem('refreshToken', '')
		  								 that.$router.go(0)
		  							}
		  						  });
		  			  }).catch(() => {
		  			  		 
		  			  });
		  },
		  showofficialQRCode(){
		  		 this.showofficialQR=true
		  },
		  hideofficialQRCode(){//隐藏二维码
		      this.showofficialQR = false
		  },
		  showserviceQRCode(){
		  			  this.showserviceQR=true
		  },
		  hideserviceQRCode(){//隐藏二维码
		      this.showserviceQR = false
		  },
		  showQRCode(){//显示二维码
		          this.showQR = true
		      },
		      hideQRCode(){//隐藏二维码
		          this.showQR = false
		      },
		      scrollToTop () {
		          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		          this.scrolltop = scrollTop
		          if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
		              this.tops = true
		          } else {
		              this.tops = false
		          }
		      },
		      gotop () {
		          let timer = setInterval(() => {
		              document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
		              if (this.scrolltop === 0) {
		                  clearInterval(timer)
		              }
		          }, 15)
		      },
		  showphonebox(){
		  		this.phoneboxshow=true  
		  },
		  closephonebox(){
		  		this.phoneboxshow=false  
		  },
		  goregister(e){
			  this.$router.push({
			    path: "/register",
			    name: "/register",
			  		  query: {
			  		  }
			  });
		  },
		  gohome(e) {
		    this.$router.push({
		      path: "/Home",
		      name: "/Home",
		  			  query: {
		  			  }
		    });
		  },
		  getpcset(){
		  		getPc().then(res=>{
		  			this.pcsetdata=res.data.data
		  		})  
		  },
		  camptypetab(val){
		  			  this.category_id=val
		  			  this.getlist()
		  },
		  pagechange(val){
			  this.page_index=val
			   this._getNewslist()
		  },
		  pagechangeLine(val){
		  			  this.page_index=val
		  			   this.getlist()
		  },
		  pagechangeCourse(val){
		  			  this.page_index=val
					  console.log("测试11",val);
		  			   this.getlist()
		  },
		  handleClick(e){
				console.log(e,this.category_id)
				 this._getNewslist()
		  },
		  onitemopen(index){
			  this.newsiconon=index
		  },
		  gettypes(){
			  var data={}
			  getActypes(data).then(res=>{
					console.log(res.data)
					this.types=res.data.data
					// this.category_id=res.data.data[0].id
					// this._getNewslist()
				}).catch(error => {
				  console.error(error);
				});
		  },
		getQuicklist(){
			var data={
				  page_index:1,
				  page_size:5,
			  }
			getTraveler(data).then(res=>{
			  			  console.log(res.data)
						  this.quicklist=res.data.data.list
			  }).catch(error => {
			  			  console.error(error);
			  			});
		},
		  getDetails(){
		  			var data={
		  				// type:this.camptype,
		  				uuid:this.uuid
		  			}  
		  			getTraveler(data).then(res=>{
						
		  				console.log(res.data)
		  				this.actdata=res.data.data
						const loading = this.$loading({
						         lock: true,
						         text: 'Loading',
						         spinner: 'el-icon-loading',
						         background: 'rgba(0, 0, 0, 0.7)'
						       });
						loading.close();
		  				// this.total=res.data.data.total
		  				// this.quicklist=res.data.data.list
		  			}).catch(error => {
		  				console.error(error);
		  			});
		  },
		
		   handleSelect(key, keyPath) {
		          console.log(key, keyPath);
		        },
	  }
	};
</script>
<style scoped>
	.bm-view {
	  width: 100%;
	  height: 600px;
	}
</style>
<style >
/* 	.baoming_tips{
		padding: 10px;
		font-size: 18px;
		color: #1b9d57;
	} */
	.pages_total{
		width: 100%;
		display: flex;
		justify-content: center;
	}
	.main_box{
		width: 1100px;
		min-height: 600px;
		margin: 0 auto;
	}
	.acttop_box{
		width: 100%;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
		background: #fff;
		    align-items: center;
		/* padding: ; */
	}
	.acttop_imgs{
		width: 375px;
		padding: 20px;
	}
	.acttop_msg{
		width:665px ;
		padding: 20px;
		padding-left: 0px;
	}
	.act_main{
		width: 100%;
		margin-top: 20px;
		background: #fff;
	}
	.actmain_item{
		padding: 20px;
	}
	.actmain_title{
		font-size:20px;
		padding-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.secret_msg{
		/* font-size: 18px; */
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.secret_msg i{
		margin: 0px 10px;
		font-size: 24px;
		color:#1b9d57;
	}
	.actblock{
		width: 10px;
		height: 40px;
		margin-right: 20px;
		display: block;
		background: #1b9d57;
	}
	::v-deep img{
	     max-width:100%;
	 }
	 .course_box{
		display: flex ;
		flex-wrap: wrap;
		width: 100%;
		margin-top: 20px;
		justify-content: space-between;
	}
	.coures_item{
		width: 340px;
		min-height: 314px;
		margin: 0px 0px 24px 0;
		border-radius: 4px;
		background: #ffffff;
		
	}
	.coures_item:hover{
		box-shadow: 0 3px 20px rgba(0,200,169,.8);
	}
	.coures_item_icon{
		position: relative;
		height: 237px;
		overflow: hidden;
	}
	.coures_item_icon img{
		width: 100%;
		height: 100%;
		-webkit-transform: scale(1);
		transform: scale(1);
		-webkit-transition: all .3s;
		transition: all .3s;
		padding: 8px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		border-radius: 12px;
/* 		-o-object-fit: scale-down;
		object-fit: scale-down; */
	}
	.coures_item_type{
		position: absolute;
		display: flex;
		justify-content: flex-end;
		flex-wrap: wrap-reverse;
		right: 0;
		z-index: 11;
		bottom: 0;
		margin: 0 3px 3px 0;
	}
	.coures_item_type span{
		display: block;
		filter: alpha(opacity=90);
		margin: 0 5px 5px 0;
		color: #fff;
		font-size: 12px;
		padding: 2px 10px;
	}
	.coures_item_title{
		font-size: 17px;
		min-height: 46px;
		height: 46px;
		width: 324px;
		padding: 8px;
		color: #333;
		text-align: left;
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
	}
	.coures_item_msg{
		padding: 0px 8px;
		text-align: left;
		color: #999;
		    font-size: 14px;
			    display: flex;
			    justify-content: space-between;
	}
	.coures_item_tags{
		display: flex;
		/* width: 100%; */
		padding: 8px;
		justify-content: flex-end;
		
	}
	 .camplist{
		margin-top: 20px;
	}
	.campitems{
		margin-bottom: 20px;
		padding: 20px;
		background: #fff;
		transition: all .3s;
		-webkit-transition: all .3s;
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: relative;
	}
	.campitems:hover{
		box-shadow: 0 3px 20px rgba(0,200,169,.8);
	}
	.campitem_imgbox{
		position: relative;
		width: 337px;
		height: 161px;
		overflow: hidden;
	}
	.campitem_imgbox img{
		width: 100%;
		height: 100%;
	}
	.campitem_tags{
		/* position: absolute; */
	/* 	    bottom: 0;
		    right: 0; */
		    z-index: 1;
			display: flex;
			justify-content: flex-start;
			align-items:center;
	}
	.campitem_tag{
		    height: 24px;
		    padding: 0 8px;
		    background: #1b9d57;
		    color: #fff;
		    line-height: 24px;
		    font-size: 12px;
			margin-left: 5px;
	}
	.campitem_msg{
		width: 750px;
		min-height: 161px;
		display: flex;
		flex-direction: column;
			margin-left: 10px;
		justify-content: space-between;
		position: relative;
		
	}
	.campitem_msg_title{
		color: #1b9d57;
		font-size: 18px;
		display: flex;
		align-items: center;
		padding: 0 10px 10px 0;
		border-bottom: 1px solid #e9e9e9;
		font-weight: 400;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		/* line-height: 24px; */
	}
	.campitem_msg_title span{
	/* 	    position: absolute;
		    top: 0;
		    left: 0; */
		    z-index: 1;
		    width: 60px;
		    height: 24px;
		    background: #1b9d57;
		    color: #fff;
		    font-size: 14px;
		    text-align: center;
			margin-right: 10px;
	}
	.campitem_msg_introduce{
		    /* height: 45px; */
		    padding-top: 15px;
		    overflow: hidden;
			text-align: left;
			line-height: 26px;
			    font-size: 14px;
			
	}
	.introduce{
		display: flex;
		align-items: center;
	}
	.campitem_msg_button{
		height: 42px;
		    /* margin-top: 15px; */
			display: flex;
			justify-content: flex-end;
			position: absolute;
			right: 0px;
			bottom: 0px;
	}
	.msg_button{
		    z-index: 1;
		    width: 134px;
		    height: 34px;
		    background: #1b9d57;
		    color: #fff;
		    line-height: 34px;
		    text-align: center;
		    border-radius: 4px;
	}
	
</style>